import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoyaltyProgramQualityKpi } from 'src/app/assabil-sales/models/dtos/loyalty-program-quality-kpi';

@Component({
  selector: 'loyalty-program-quality-kpi',
  templateUrl: './loyalty-program-quality-kpi.component.html',
  styleUrls: ['./loyalty-program-quality-kpi.component.scss']
})
export class LoyaltyProgramQualityKpiComponent implements OnInit {

  @Input() geoArea    ;
  @Input() loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi;
  @Input() previousPeriod : string;

  @Output() onClick        = new EventEmitter<any>();

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle()            { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Count"} );} 
  clickPrivilege()        { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Privilege"} );} 
  clickAssetAbused()      { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "AssetAbused"} );} 
  clickAssetVisible()     { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "AssetVisible"} );} 
  clickAssetReachable()   { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "AssetReachable"} );} 
  clickDeniedVisit()      { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "DeniedVisit"} );} 
  clickClosedPartner()    { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "ClosedPartner"} );} 
  clickOtherAnomaly()     { this.onClick.emit({loyaltyProgram : this.loyaltyProgramQualityKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "OtherAnomaly"} );} 

  getPrivilegeRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round((loyaltyProgramQualityKpi.totalCount !=0 ? (loyaltyProgramQualityKpi.privilegeCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0));
  }
  getAssetAbusedRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round((loyaltyProgramQualityKpi.totalCount != 0 ? (loyaltyProgramQualityKpi.assetAbusedCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0));
  }
  getAssetVisibleRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round(( loyaltyProgramQualityKpi.totalCount != 0 ? (loyaltyProgramQualityKpi.assetVisibleCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0));
  }
  getAssetReachableRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round(( loyaltyProgramQualityKpi.totalCount != 0 ? (loyaltyProgramQualityKpi.assetReachableCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0));
  }
  getDeniedVisitRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round( loyaltyProgramQualityKpi.totalCount != 0 ? (loyaltyProgramQualityKpi.deniedVisitCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0 );
  }
  getOtherAnomalyRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round( loyaltyProgramQualityKpi.totalCount != 0 ? (loyaltyProgramQualityKpi.otherAnomalyCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0 );
  }
  getClosedPartnerRate(loyaltyProgramQualityKpi : LoyaltyProgramQualityKpi) {
    return Math.round( loyaltyProgramQualityKpi.totalCount != 0 ? (loyaltyProgramQualityKpi.closedPartnerCount * 100 / loyaltyProgramQualityKpi.totalCount) : 0 );
  }

}


